import { IAction } from '../action';

// #region -------------- Action types -------------------------------------------------------------------

export const actionTypes = {
  loadCurrentUser: 'login/LOAD_CURRENT_USER',
  currentUserLoaded: 'login/CURRENT_USER_LOADED',
  logIn: 'login/LOG_IN',
  logOut: 'login/LOG_OUT',
};

// #endregion

// #region -------------- Actions -------------------------------------------------------------------

export interface ILoginPayload {
  userName: string;
  password: string;
}

export function loadCurrentUser() {
  return {
    type: actionTypes.loadCurrentUser,
  };
}

export function login(payload: ILoginPayload): IAction {
  return {
    type: actionTypes.logIn,
    payload,
  };
}

export function logout() {
  return {
    type: actionTypes.logOut,
  };
}

// #endregion
